// JS actulaiza datos de el carrito de compras y los almacena en localstorage

js_update_cart()
function js_update_cart(){
    document.addEventListener('DOMContentLoaded', updateCart)
}

function updateCart() {
    const contents = document.querySelectorAll('.js-update-cart')

    contents.forEach(content => {
        const buttons = content.querySelectorAll('.js-update-cart__button')
        const input = content.querySelector('.js-update-cart__input')

        buttons.forEach(button => {
            button.addEventListener('click', () => {
                actualizarLine(content.dataset.id, input.value)
            })
        })
    })

    function actualizarLine(id, num){
        $.ajax({
            url: "/cart/change",
            type: "post",
            data: {
                id: id,
                quantity: num
            },
            dataType: 'json',
            async: false,
            success: res => {
                localStorage.setItem('atom_cart', JSON.stringify(res))
            },
            error: err => {
                console.log(err)
            }
        }) 
    }
}
